import React, { Suspense } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import { connect } from "react-redux";
import Loader from "../../components/loader";
import AuthRoutes from "./AuthRoutes";
import SignIn from "../../containers/SignIn";
import ResetPassword from "../../containers/SignIn/restPassword";
import SetPassword from "../../containers/SignIn/setPassword";
import { Row, Col } from "antd";
import {
  AiOutlineTwitter,
  FaFacebookF,
  FaLinkedinIn,
  FaInstagram,
  AiOutlineYoutube,
} from "react-icons/all";
import Not_found from "../../containers/SignUp/not_found";
import Newpassword from "../../containers/SignIn/newpassword";
// import ValidateUser from "../../containers/SignUp/expiredlink"
// import StoreDown from "../../containers/SignUp/storedown";
import { AuthAction } from "../../store/actions";
import SurfaceLogo from "../../assets/images/surface-logo.png";

class Routes extends React.Component {
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    const { storeName, error } = this.props;
    console.log("property", this.props);
    return (
      <Suspense fallback={<Loader />}>
        {storeName?.rmx_company_asset ? (
          <Switch>
            {!this.props.isAuthenticated ? (
              <React.Fragment>
                {!(
                  !!window?.location?.pathname?.includes("expired_link") ||
                  !!window?.location?.pathname?.includes("404") ||
                  !!window?.location?.pathname?.includes("store_down")
                ) && (
                  <Row justify="center">
                    <Col
                      span={20}
                      style={{
                        padding: "0.8rem",
                        position: "absolute",
                        borderBottom: "solid white 2px",
                      }}
                    >
                      <Row align="middle" justify="space-between">
                        <Col
                          xl={6}
                          lg={8}
                          md={8}
                          xs={24}
                          sm={24}
                          className="text-left"
                        >
                          <img width="60%" src={SurfaceLogo} />
                        </Col>

                        <Col xl={4} className="text-right">
                          {/* <Row className="text-right" justify="end">
                            <Col xl={4}>
                              <a
                                href="https://www.linkedin.com/company/10687685/"
                                target={"_blank"}
                              ></a>
                              <FaLinkedinIn color="white" size="25" />
                            </Col>

                            <Col xl={4}>
                              <a
                                target={"_blank"}
                                href="https://twitter.com/SurfaceTech_LLC"
                              >
                                <AiOutlineTwitter color="white" size="25" />
                              </a>
                            </Col>
                            <Col xl={4}>
                              <a
                                target={"_blank"}
                                href="https://www.facebook.com/Surface-Tech-211543822585857/"
                              >
                                <FaFacebookF color="white" size="25" />
                              </a>
                            </Col>
                            <Col xl={4}>
                              <a target={"_blank"}></a>
                              <FaInstagram color="white" size="25" />
                            </Col>
                            <Col xl={4}>
                              <a target={"_blank"}></a>
                              <AiOutlineYoutube color="white" size="25" />
                            </Col>
                          </Row> */}
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                )}
                <Switch>
                  <Route exact path="/404" component={Not_found} />
                  <Route exact path="/setpassword" component={SetPassword} />
                  <Route exact path="/forgot" component={ResetPassword} />
                  <Route exact path="/reset_password" component={Newpassword} />
                  <Route exact path="/signin" component={SignIn} />
                  {/* <Route
                    exact
                    path="/expired_link"
                    component={ValidateUser}
                  /> */}
                  {/* <Route
                    exact
                    path="/store_down"
                    component={StoreDown}
                  /> */}
                  <Route path="*" render={() => <Redirect to="/signin" />} />
                </Switch>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <Switch>
                  <Route path="/" component={AuthRoutes} />
                  <Route exact path="*" component={Not_found} />
                </Switch>
              </React.Fragment>
            )}
          </Switch>
        ) : (
          <React.Fragment>
            {error && (
              <Switch>
                <Route exact path="*" component={Not_found} />
              </Switch>
            )}
          </React.Fragment>
        )}
      </Suspense>
    );
  }
}

// const ProtectedRoute = ({ enabled, ...props }) => (
//   enabled && <Route {...props} />
// )

export default connect((storeState) => {
  return {
    isAuthenticated: storeState.AuthReducer?.isAuthenticated,
    storeName: storeState.AuthReducer.storeInfo,
    error: storeState.AuthReducer.error,
  };
})(Routes);
